// extracted by mini-css-extract-plugin
export default {"container":"ActivityPeopleField_container__A6esm"};